var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteLeft = function SvgQuoteLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 17c0-3.869 3.131-7 7-7h2a1 1 0 1 1 0 2h-2c-2.763 0-5 2.238-5 5a1 1 0 0 0 1 1h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V17m16 7v-7c0-3.869 3.131-7 7-7h2a1 1 0 1 1 0 2h-2c-2.763 0-5 2.238-5 5a1 1 0 0 0 1 1h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2z"
  })));
};
export default SvgQuoteLeft;